import { useState } from 'react'
import theme from 'tailwindcss/defaultTheme'
import { useIsomorphicLayoutEffect } from '@/hooks'

export const useWindowSize = () => {
    const [isWideScreen, setIsWideScreen] = useState(false)
    useIsomorphicLayoutEffect(() => {
        const screenMD = Number(theme.screens.md.replace('px', ''))
        const handleResize = () => {
            setIsWideScreen(window.innerWidth > screenMD)
        }
        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return isWideScreen
}
